<template>
  <div class="home">
    <v-toolbar>
      <v-icon>mdi-clipboard-text</v-icon>
      <v-spacer></v-spacer>
      <v-toolbar-title class="app-title">ListWorks</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="goToInvites">
        <p>{{ numberOfInvites }}</p>
        <v-icon>mdi-account-multiple</v-icon>
      </v-btn>
    </v-toolbar>
    <div id="userInfoContainer">
      User: {{ userProfile.name }} ({{ userProfile.email }})
    </div>
    <MyShoppingLists />
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState } from "vuex";
import MyShoppingLists from "@/components/MyShoppingLists.vue";
const fb = require("../firebaseConfig.js");

export default {
  name: "home",
  data: () => ({
    unsubscribeListener: null,
    numberOfInvites: null
  }),
  components: {
    MyShoppingLists
  },
  computed: {
    ...mapState(["userProfile", "currentUser", "pendingInvites"])
  },
  methods: {
    fetchInvites() {
      this.unsubscribeListener = fb.pendingListInvitesCollection
        .where("to_user_id", "==", this.currentUser.uid)
        .onSnapshot(querySnapshot => {
          let invites = [];

          querySnapshot.forEach(doc => {
            let invite = doc.data();
            invite.id = doc.id;
            invites.push(invite);
          });
          this.numberOfInvites = invites.length;
          this.$store.commit("setPendingInvites", invites);
        });
    },
    goToInvites() {
      this.$router.push({ name: "invites" });
    }
  },
  created() {
    this.fetchInvites();
  },
  destroyed() {
    this.unsubscribeListener();
  }
};
</script>

<style lang="scss">
.v-btn {
  margin-right: 10px;
}
.app-title {
  font-weight: bold;
  color: #1abc9c;
}
#userInfoContainer {
  padding: 10px 0;
  background: #ebebeb;
}
</style>
